import React from 'react'

import { formatVal } from '../../../../CustomFieldInput/Date'

type DateCustomFieldCellProps = {
  value: string
  customField: LocalCustomField
}

const DateCustomFieldCell: React.FC<DateCustomFieldCellProps> = ({
  value,
  customField
}) => {
  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      {formatVal({ type: customField.field_type, value, fallback: ' ' })}
    </div>
  )
}

export default DateCustomFieldCell
